"use strict";
var _ItemAvailabilityImpl_model, _ItemAvailabilityImpl_response, _ItemAvailabilityImpl_deserialized, _ItemAvailabilityImpl_items;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemAvailability = exports.deserializeHelper = void 0;
const tslib_1 = require("tslib");
const lodash_get_1 = tslib_1.__importDefault(require("lodash.get"));
const deserializer_1 = tslib_1.__importDefault(require("../../../../utils/deserializer"));
const structured_clone_1 = tslib_1.__importDefault(require("@ungap/structured-clone"));
function deserializeHelper(response) {
    const deserializedData = (0, deserializer_1.default)(response);
    return deserializedData;
}
exports.deserializeHelper = deserializeHelper;
class ItemAvailability {
    constructor(data) {
        this.itemId = data.itemId;
        this.remaining_quantity = data.remaining_quantity;
        this.allow_overbooking = data.allow_overbooking;
        this.track_quantity = data.track_quantity;
        this.start_at = data.start_at;
        this.end_at = data.end_at;
        this.isFullPeriod = data.isFullPeriod;
        this.suggested_booking_cost_cents = data.suggested_booking_cost_cents;
    }
}
exports.ItemAvailability = ItemAvailability;
class ItemAvailabilityImpl {
    constructor(items) {
        _ItemAvailabilityImpl_model.set(this, []);
        _ItemAvailabilityImpl_response.set(this, void 0);
        _ItemAvailabilityImpl_deserialized.set(this, []);
        _ItemAvailabilityImpl_items.set(this, []);
        tslib_1.__classPrivateFieldSet(this, _ItemAvailabilityImpl_items, items, "f");
        this.mapperObject = this.mapperObject.bind(this);
        this.updateModel = this.updateModel.bind(this);
        this.deserialize = this.deserialize.bind(this);
    }
    set response(reponse) {
        tslib_1.__classPrivateFieldSet(this, _ItemAvailabilityImpl_response, reponse.data, "f");
        this.deserialize();
        this.updateModel();
    }
    set deserializedResponse(data) {
        tslib_1.__classPrivateFieldSet(this, _ItemAvailabilityImpl_deserialized, data, "f");
        this.updateModel();
    }
    deserialize() {
        const isObject = !Array.isArray(tslib_1.__classPrivateFieldGet(this, _ItemAvailabilityImpl_response, "f").data);
        if (isObject) {
            const payload = (0, structured_clone_1.default)(tslib_1.__classPrivateFieldGet(this, _ItemAvailabilityImpl_response, "f"));
            payload['data']['attributes'] = Object.assign(payload['data']['attributes'], { itemId: (0, lodash_get_1.default)(payload, 'data.relationships.item.data.id', 0) });
            const deserializedData = deserializeHelper(payload);
            tslib_1.__classPrivateFieldSet(this, _ItemAvailabilityImpl_deserialized, deserializedData.data, "f");
            return;
        }
        const payload = (0, structured_clone_1.default)(tslib_1.__classPrivateFieldGet(this, _ItemAvailabilityImpl_response, "f"));
        payload['data'].map((availabilityItem) => {
            availabilityItem['attributes'] = Object.assign(availabilityItem['attributes'], { itemId: (0, lodash_get_1.default)(availabilityItem, 'relationships.item.data.id', 0) });
            return availabilityItem;
        });
        const deserializedData = deserializeHelper(payload);
        tslib_1.__classPrivateFieldSet(this, _ItemAvailabilityImpl_deserialized, deserializedData.data, "f");
    }
    updateModel() {
        if (Array.isArray(tslib_1.__classPrivateFieldGet(this, _ItemAvailabilityImpl_deserialized, "f"))) {
            const notFlatResponse = tslib_1.__classPrivateFieldGet(this, _ItemAvailabilityImpl_deserialized, "f").map(this.mapperObject);
            tslib_1.__classPrivateFieldSet(this, _ItemAvailabilityImpl_model, notFlatResponse.flat(), "f");
        }
        if (!Array.isArray(tslib_1.__classPrivateFieldGet(this, _ItemAvailabilityImpl_deserialized, "f"))) {
            const notFlatResponse = this.mapperObject(tslib_1.__classPrivateFieldGet(this, _ItemAvailabilityImpl_deserialized, "f"));
            tslib_1.__classPrivateFieldSet(this, _ItemAvailabilityImpl_model, notFlatResponse.flat(), "f");
        }
    }
    mapperObject(bookingItem) {
        // Item object
        const itemId = bookingItem.itemId;
        const item = (tslib_1.__classPrivateFieldGet(this, _ItemAvailabilityImpl_items, "f") || []).find((item) => Number(item.id) === Number(itemId));
        const isFullPeriod = true;
        const start_at = bookingItem.start_at;
        const end_at = bookingItem.end_at;
        // allow_overbooking from Item object
        const allow_overbooking = typeof (item === null || item === void 0 ? void 0 : item.allow_overbooking) === 'boolean'
            ? item === null || item === void 0 ? void 0 : item.allow_overbooking
            : false;
        // track_quantity from Item object
        const track_quantity = typeof (item === null || item === void 0 ? void 0 : item.track_quantity) === 'boolean' ? item === null || item === void 0 ? void 0 : item.track_quantity : false;
        if (!Number.isInteger(bookingItem.remaining_quantity))
            return [];
        return [
            new ItemAvailability({
                itemId: Number(itemId),
                remaining_quantity: bookingItem.remaining_quantity,
                track_quantity,
                allow_overbooking,
                start_at,
                end_at,
                isFullPeriod,
                suggested_booking_cost_cents: bookingItem.suggested_booking_cost_cents,
            }),
        ];
    }
    get data() {
        return tslib_1.__classPrivateFieldGet(this, _ItemAvailabilityImpl_model, "f").map((item) => ({ ...item }));
    }
}
exports.default = ItemAvailabilityImpl;
_ItemAvailabilityImpl_model = new WeakMap(), _ItemAvailabilityImpl_response = new WeakMap(), _ItemAvailabilityImpl_deserialized = new WeakMap(), _ItemAvailabilityImpl_items = new WeakMap();
//# sourceMappingURL=ItemAvailability.js.map